import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addCategory } from '../../services/Configs/ItemCategoriesService'

function AddItemCategoryModal({ show, handleClose, handleReload }) {
  const [categoryName, setCategoryName] = useState("");

  const handleChangeCategoryName = (e) => {
    const { value } = e.target;
    setCategoryName(value);
  }

  const handleAddCategory = () => {
    let pendingInputs = [];

    if (!categoryName) {
      pendingInputs.push("Categoría")
    }

    if (pendingInputs.length == 0) {

      addCategory(categoryName).then(categoryResult => {
        toast.success('Categoría creada correctamente');
        handleClose();
        handleReload();
      });
    }
    else {
      toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }

  useEffect(() => {
    if (show) {
      setCategoryName("");
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Agregar Categoría</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Nombre:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="categoryName"
                placeholder='Nombre de la categoría'
                value={categoryName}
                onChange={handleChangeCategoryName}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleAddCategory}>
          Guardar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddItemCategoryModal;